export default function initializePagination() {
    document.querySelectorAll('.pagination').forEach(function (block) {
        new PaginationGo(block);
    });
}

class PaginationGo {
    constructor(block) {
        this.block = block;
        this.form = this.block.querySelector('.go-to__form');
        if (!this.form) return;

        this.input = this.form.querySelector('input[name="page"]');
        if (!this.input) return;

        // Створюємо елемент лоадера
        this.loader = document.createElement('span');
        this.loader.classList.add('go-to__loader');
        this.loader.innerHTML = `<span class="spinner"></span>`; // можна замінити на SVG або SVG inline

        // Події
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.goToPage();
        });

        this.input.addEventListener('change', () => this.goToPage());
        this.input.addEventListener('input', () => {
            this.input.classList.remove('error');
        });
    }

    showLoader() {
        // Замінюємо інпут на лоадер
        this.input.style.display = 'none';
        this.form.appendChild(this.loader);
    }

    hideLoader() {
        // Повертаємо інпут
        this.loader.remove();
        this.input.style.display = '';
    }

    goToPage() {
        const page = parseInt(this.input.value.trim(), 10);

        if (isNaN(page) || page < 1) {
            this.input.classList.add('error');
            return false;
        }

        this.showLoader(); // показуємо лоадер

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('paged', page);

        // невелика затримка для ефекту
        setTimeout(() => {
            window.location.href = currentUrl.toString();
        }, 100);
    }
}
